import React, {useEffect, useState} from "react";
import {QuestionInputProps} from "../Question";
import {createUseStyles, useTheme} from "react-jss";
import {TriviaStatus} from "../../../state/state";
import TextField from "engage-client/components/TextField";
import SubmitButton from "../../common/SubmitButton";
import {PhraseQuestionDefinition} from "../../../state/questions";
import {Phrase} from "../common/Phrase";
import Explanation from "../common/Explanation";
import {Theme} from "engage-client/theme";

const useStyles = createUseStyles<Theme>((theme) => ({
	form: {
		display: "flex",
		margin: 16,
		[theme.breakpoints.down("md")] : {
			flexDirection: "column",
		}
	},
	input: {
		flex: 1,
		marginRight: 16,
		[theme.breakpoints.down("md")] : {
			marginRight: 0,
			marginBottom: 16,
		}
	}
}));

export default function PhraseInput({state, question, onSubmit, response, aggregateResponses}: QuestionInputProps) {
	const theme: Theme = useTheme();
	const classes = useStyles();
	const [phrase, setPhrase] = useState<string>();
	const phraseQuestion = question as PhraseQuestionDefinition;
	const responses = response?.value as string[];

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPhrase(e.target.value);
	};

	const submit = (e:React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (phrase?.length) {
			const array = responses ? [...responses] : [];
			array.push(phrase.toUpperCase());
			onSubmit(array);
		}
	};

	useEffect(() => {
		if(state === TriviaStatus.QuestionStart) {
			setPhrase(undefined);
		}
	}, [state]);

	const correct = response && response.score > 0;
	let helperText = "Submit your guess!";
	let errorText:string|undefined;
	let overridePhrase:string|undefined;
	if(response) {
		if(correct) {
			overridePhrase = responses[responses.length-1];
			helperText = "You got it!";
		} else {
			errorText = "Try again!";
		}
	}

	return <div data-qa="phrase-input">
			<Phrase question={phraseQuestion}/>
		{state === TriviaStatus.QuestionSubmit &&
		<form className={classes.form}
			  onSubmit={submit}>
			<TextField labelText="Answer" variant="filled" autoComplete="off" autoFocus
					   onChange={onChange} value={overridePhrase ?? phrase} disabled={correct}
					   name="phraseInput" className={classes.input}
					   helperText={helperText} errorText={errorText}
					   backgroundColor="white" backgroundHoverColor="#f4f4f6"
					   foregroundColor={theme.phrase.foregroundColor} foregroundHoverColor={theme.phrase.foregroundFocusColor} foregroundFocusColor={theme.phrase.foregroundFocusColor}
					   textColor="black"/>
			<SubmitButton disabled={phrase === undefined || phrase.length === 0 || correct}
						  type="submit">Submit</SubmitButton>
		</form>
		}
		{state === TriviaStatus.QuestionDetails &&
			<Explanation question={question} aggregateResponses={aggregateResponses} showFastest={false}/>
		}
	</div>;
}